import { useCompleteFragment } from '@eluve/apollo-client';
import { graphql } from '@eluve/graphql.tada';

export const appointmentTotalDurationFragment = graphql(`
  fragment appointmentTotalDuration on Appointments @_unmask {
    totalDuration
  }
`);

export const getAppointmentTotalDuration = graphql(
  `
    query getAppointmentTotalDuration($appointmentId: uuid!, $tenantId: uuid!) {
      appointmentsByPk(id: $appointmentId, tenantId: $tenantId) {
        __typename
        id
        ...appointmentTotalDuration
      }
    }
  `,
  [appointmentTotalDurationFragment],
);

export const useAppointmentTotalDuration = (appointmentId: string) => {
  const data = useCompleteFragment({
    fragment: appointmentTotalDurationFragment,
    strict: false,
    key: {
      id: appointmentId,
    },
  });

  return data?.totalDuration ?? 0;
};
